import type { AuthUser } from '@types';

/**
 * Owner-area access predicate (F1.3/F1.7/F9.1). The single source of truth used
 * by both the nav (hide links) and the OwnerRoute guard (block deep links), so
 * the two can never disagree. Only an active owner may reach Settings/Users.
 */
export function canAccessOwnerArea(
  user: Pick<AuthUser, 'role' | 'is_active'> | null | undefined
): boolean {
  return user?.role === 'owner' && user.is_active === true;
}
